<template>
  <div class="radioContext">
    <div v-if="show" v-for="method in shippingMethods" :key="method.payWayId" style="width:100%;overflow: hidden;">
      <div class="flex">
        <div>{{ method.cnName }}</div>
        <div class="flex">
          <SfImage v-if="method.logoUrl" :alt="method.cnName" class="empty-cart__image payImage" :src="method.logoUrl"
            :width="128" :height="128"></SfImage>
        </div>
      </div>
      <div style="display:flex;flex-wrap: wrap;">
        <SfRadio v-for="currency in method.currencies" :key="currency" :value="method.payWayId + currency"
          :selected="selectedCurreny" @change="selectCurreny(method, currency)">
          <template #label>
            <div v-html="currency"></div>
          </template>
        </SfRadio>
      </div>
    </div>
    <div>
      <SfButton v-if="selectedMethod+'' === '-999'" @click="$emit('thankyou')" style="margin-bottom:1rem">{{ $t('confirm') }}</SfButton>
    </div>
  </div>
</template>

<script>
import { SfButton, SfRadio, SfImage } from '@storefront-ui/vue';
import { ref, computed, onMounted, useRoute } from '@nuxtjs/composition-api';
import { usePreviewOrderStore } from '~/stores/previewOrder';
import { usePaymethod, useOrderCheckoutDetails } from '@bee-hole/coms';
// const SHIPPING_METHODS = [
//   { label: 'Visa Debit', value: 'visa_debit' },
//   { label: 'MasterCard', value: 'master_card' },
//   { label: 'VisaElectron', value: 'visa_electron' },
//   { label: 'Cash on delivery', value: 'cash' },
//   { label: 'Check', value: 'check' }
// ];

export default {
  name: 'VsfPaymentProvider',
  components: {
    SfButton,
    SfRadio,
    SfImage
  },
  props: {
    hidden: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit, root }) {
    const { getDetails, result } = useOrderCheckoutDetails();
    const show = computed(() => {
      return !(props.hidden && props.hidden !== undefined);
    });
    const { load: loadPayMethod, paymethod } = usePaymethod();
    const route = useRoute();
    const orderNumber = ref(route.value.query.orderNumber);
    const previewOrderStore = usePreviewOrderStore();
    const selectedMethod = ref();
    const selectedCurreny = ref();
    const selectMethod = (method) => {
      previewOrderStore.setPaymethod(method);
      selectedMethod.value = String(method.payWayId);
      // emit('status');
    };
    const selectCurreny = (method, currency) => {
      selectMethod(method);
      previewOrderStore.setPaymethodCurreny(currency);
      selectedCurreny.value = (method.payWayId + currency);
      emit('status');
    };
    const adress = computed(() => {
      return result.value?.address;
    });
    const payMethods = computed(() => {
      if (paymethod?.value?.list) {
        const array = JSON.parse(JSON.stringify(paymethod?.value?.list));
        // const content = root?.$options?.$mallConfig.mall_xianxia_pay?.content;
        // if (content) {
        //   array.push({
        //     cnName: '',
        //     enName: '',
        //     currencies: [(content)],
        //     payWayId: -999
        //   });
        // }
        const mallXianxiaPay = root?.$options?.$mallConfig.mall_xianxia_pay;
        if (mallXianxiaPay && mallXianxiaPay.content && (((!mallXianxiaPay.trading_countries) || (mallXianxiaPay.trading_countries && mallXianxiaPay.trading_countries.length === 0)) || (mallXianxiaPay.trading_countries && mallXianxiaPay.trading_countries.length && adress.value?.country && mallXianxiaPay.trading_countries.indexOf(adress.value?.country) !== -1))) {
          array.push({
            cnName: '',
            enName: '',
            currencies: [(mallXianxiaPay.content)],
            payWayId: -999
          });
        }
        return array;
      }
    });

    onMounted(async () => {
      try {
        let query = {
          prepay_id: orderNumber.value
        };
        if (route.value.query.is_manual_payment) {
          query.is_manual_payment = true;
        }
        await getDetails(query);
      } catch (e) {
        console.log('error', e);
      }
      await loadPayMethod({ prepay_id: String(orderNumber.value) });
      if (paymethod.value === null) {
        await previewOrderStore.clearIdCard();
        emit('initBack');
      } else {
        await previewOrderStore.setIdNumber(paymethod.value?.idNumber);
        await previewOrderStore.setIdName(paymethod.value?.idName);
        await previewOrderStore.setIdType('1');
        await previewOrderStore.setHasIdentity(paymethod.value?.hasIdentity);
        emit('initBack');
      }
      if (payMethods.value?.length === 1) {
        if (payMethods.value[0]?.currencies?.length === 1) {
          selectCurreny(payMethods.value[0], payMethods.value[0]?.currencies[0]);
        } else {
          selectMethod(payMethods.value[0]);
        }
      }
      if (props.checked && previewOrderStore.paymethod) {
        selectedMethod.value = String(previewOrderStore.paymethod.payWayId);
        if (previewOrderStore.paymethodCurreny) {
          selectedCurreny.value = (previewOrderStore.paymethod.payWayId + previewOrderStore.paymethodCurreny);
        }
      } else if (payMethods?.length) {
        selectMethod(payMethods[0]);
      }
    });
    return {
      shippingMethods: payMethods,
      selectedMethod,
      selectMethod,
      show,
      selectCurreny,
      selectedCurreny
    };
  }
};
</script>

<style lang="scss" scoped>
.shipping {
  &__label {
    display: flex;
    justify-content: space-between;
  }

  &__description {
    --radio-description-margin: 0;
    --radio-description-font-size: var(--font-xs);
  }
}

.radioContext {
  display: flex;
  flex-flow: column wrap;
}

.flex {
  display: flex;
  align-items: center;
}
</style>
<style lang="scss">
.radioContext{
  .payImage {
    // height: 2rem;
    object-fit: contain;
    margin: 0 0 0 0 !important;
    img {
      height: 1rem;
      width: auto !important;
      margin-left: 10px;
    }
  }
  .sf-radio__content{
    p{
      margin-top: 0;
    }
    align-content: center;
  }
}

</style>
